import React from "react";
import { FaGlobe, FaNodeJs, FaReact } from "react-icons/fa";
import { BiLogoMongodb } from "react-icons/bi";
import { SiMicrosoftsqlserver, SiMysql, SiTailwindcss } from "react-icons/si";
import { RiJavascriptFill } from "react-icons/ri";
import { BsGit } from "react-icons/bs";
import { AiFillGithub } from "react-icons/ai";

import { Link as ScrollLink } from "react-scroll";
import Expressjs from "../../assets/icons/express.png";
import MaterialUI from "../../assets/icons/material ui.png";
import dotnetcore from "../../assets/icons/dotnetcore.png";
import CursorIcon from "../../assets/icons/cursor.png";
import AntigravityIcon from "../../assets/icons/antigravity.png";
import SupabaseIcon from "../../assets/icons/supabase.png";
import N8nIcon from "../../assets/icons/n8n.png";
import NextjsIcon from "../../assets/icons/nextjs.png";
import FirebaseIcon from "../../assets/icons/firebase.png";
import HelloIcon from "../../assets/4.png";

const herosectionData = {
  name: "Zafirul Islam",
};

const skills = [
  {
    icon: <FaReact size={24} />,
    color: "rgb(0, 201, 247)",
    name: "React"
  },
  {
    icon: <img src={NextjsIcon} alt="Next.js" />,
    name: "Next.js"
  },
  {
    icon: <FaNodeJs size={24} />,
    color: "green",
    name: "NodeJs"
  },
  {
    icon: <img src={Expressjs} alt="Express Js" />,
    name: "Express Js"
  },
  {
    icon: <BiLogoMongodb size={24} />,
    color: "green",
    name: "MongoDB"
  },
  {
    icon: <SiTailwindcss size={24} />,
    color: "#06B6D4",
    name: "TailwindCSS"
  },
  {
    icon: <img src={MaterialUI} alt="Material UI" />,
    name: "MaterialUI"
  },
  {
    icon: <RiJavascriptFill size={24} />,
    color: "#ee9d03",
    name: "JavaScript"
  },
  {
    icon: <img src={dotnetcore} alt=".NET Core" />,
    name: ".NET Core"
  },
  {
    icon: <FaGlobe size={24} />,
    color: "rgb(82, 35, 201)",
    name: "Web APIs"
  },
  {
    icon: <SiMicrosoftsqlserver size={24} />,
    color: "purple",
    name: "MS-SQL"
  },
  {
    icon: <SiMysql size={24} />,
    color: "#0846a8",
    name: "My-SQL"
  },
  {
    icon: <BsGit size={24} />,
    color: "#f14f07",
    name: "Git"
  },
  {
    icon: <AiFillGithub size={24} />,
    color: "#000",
    name: "GitHub"
  },
  {
    icon: <img src={SupabaseIcon} alt="Supabase" />,
    name: "Supabase"
  },
  {
    icon: <img src={FirebaseIcon} alt="Firebase" />,
    name: "Firebase"
  },
  {
    icon: <img src={CursorIcon} alt="Cursor" />,
    name: "Cursor"
  },
  {
    icon: <img src={AntigravityIcon} alt="Antigravity" />,
    name: "Antigravity"
  },
  {
    icon: <img src={N8nIcon} alt="n8n" />,
    name: "n8n"
  },
];

function Herosection() {
  const currentYear = new Date().getFullYear();
  const itExperience = currentYear - 2021;
  const freelanceYears = 2;
  const professionalYears = itExperience - freelanceYears;

  return (
    <section
      className="hero background parallax shadow-dark d-flex align-items-center"
      style={{ backgroundImage: "url(/images/zaf-img-2.jpg)" }}
    >
      <div className="cta mx-auto mt-1">
        <h1 className="forhero-h1">
          Hey <img src={HelloIcon} className="helloIcon" alt="Icon" /> I'm <br />{herosectionData.name}
        </h1>

        <p className="mb-3 hero-summary" style={{ fontSize: "16px", lineHeight: "1.8", color: "#f0f0f0" }}>
          Full Stack Developer & Engineering Manager with{" "}
          <strong style={{ color: "#c9ff04" }}>{itExperience}+ Years</strong> of IT
          experience ({freelanceYears} yrs freelancing +{" "}
          <strong style={{ color: "#c9ff04" }}>{professionalYears}+ yrs</strong>{" "}
          professional).
          <br />
          Currently leading scalable web platforms and AI-driven workflows as{" "}
          <strong style={{ color: "#c9ff04" }}>Manager at TECHUNIQUEIIT</strong>.
        </p>

        <div className="tech-chips">
          {skills.map((skill, index) => (
            <span key={index} className="tech-chip">
              <i style={{ color: skill.color }}>
                {skill.icon}
              </i>
              {skill.name}
            </span>
          ))}
        </div>

        <ScrollLink
          activeClass="active"
          to="section-portfolios"
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-default btn-lg mr-3"
        >
          <i className="icon-grid"></i>View Portfolio
        </ScrollLink>

        <ScrollLink
          activeClass="active"
          to="section-contact"
          spy={true}
          smooth={true}
          duration={500}
          offset={50}
          className="btn btn-border-light btn-lg"
        >
          <i className="icon-envelope"></i>Hire me
        </ScrollLink>
      </div>
      <div className="overlay"></div>
    </section>
  );
}

export default Herosection;
